// ** React Imports
import { useEffect } from "react";
import { NavLink } from "react-router-dom";

// ** Third Party Components
import { Disc, X, Circle } from "react-feather";

// ** Config

import invocomHeaderLogo from "../../../../../assets/images/icons/customIcons/WidgetIcon1.svg";
import Tooltip from "@tooltip/index";

const VerticalMenuHeader = (props) => {
  // ** Props
  const {
    menuCollapsed,
    setMenuCollapsed,
    setMenuVisibility,
    setGroupOpen,
    menuHover,
  } = props;

  // ** Reset open group
  useEffect(() => {
    if (!menuHover && menuCollapsed) setGroupOpen([]);
  }, [menuHover, menuCollapsed, setGroupOpen]);

  // ** Menu toggler component
  const Toggler = () => {
    if (!menuCollapsed) {
      return (
        <Disc
          size={20}
          data-tour="toggle-icon"
          className="toggle-icon d-none d-xl-block"
          onClick={() => setMenuCollapsed(true)}
        />
      );
    } else {
      return (
        <Circle
          size={20}
          data-tour="toggle-icon"
          className=" toggle-icon d-none d-xl-block"
          onClick={() => setMenuCollapsed(false)}
        />
      );
    }
  };

  return (
    <div className="navbar-header">
      <ul className="nav navbar-nav flex-row">
        <li className="nav-item mr-auto">
          <NavLink to="/home" className="navbar-brand">
          
            <span className="brand-logo">
            <Tooltip text="Go on Dashboard" position="right">
              <img
                loading="lazy"
                src={invocomHeaderLogo}
                alt="logo"
                style={{
                  border: "2px solid rgba(196, 196, 196, 0.5)",
                  padding: "3px",
                  borderRadius: "8px",
                  marginLeft: "-2px",
                }}
              />
               </Tooltip>
            </span>
           
          </NavLink>
        </li>

        <li className="nav-item nav-toggle">
          <div className="nav-link modern-nav-toggle cursor-pointer">
            <Toggler />
            <X
              onClick={() => setMenuVisibility(false)}
              className="toggle-icon icon-x d-block d-xl-none"
              size={20}
            />
          </div>
        </li>
      </ul>
    </div>
  );
};

export default VerticalMenuHeader;
